import client from './client';

export function getFilterOptions() {
  return client.get('/api/statistics/filter-options');
}

export function getUsersProgress(params) {
  return client.get('/api/statistics/users-progress', { params });
}

export function getFilterPreference(params) {
  return client.get('/api/statistics/filter-preference', { params });
}

export function saveFilterPreference(filters) {
  return client.put('/api/statistics/filter-preference', { filters });
}

export function getAggregate(params) {
  return client.get('/api/statistics/aggregate', { params });
}

export function getNotes(year) {
  return client.get(`/api/statistics/notes?year=${year}`);
}

export function saveNote(userId, year, note) {
  return client.post('/api/statistics/notes', { userId, year, note });
}

export function getUserLogbook(userId, params) {
  return client.get(`/api/statistics/user-logbook/${userId}`, { params });
}

export function markDuplicateReviewed(userId, duplicateKey, reviewNote = '') {
  return client.post('/api/statistics/duplicate-reviews', { userId, duplicateKey, reviewNote });
}

export function markDuplicateFollowUp(userId, duplicateKey) {
  return client.post('/api/statistics/duplicate-followups', { userId, duplicateKey });
}

export function removeDuplicateFollowUp(userId, duplicateKey) {
  return client.delete('/api/statistics/duplicate-followups', { data: { userId, duplicateKey } });
}

export function getKeywordOverview(params) {
  return client.get('/api/statistics/keywords/overview', { params });
}

export function getKeywordMappingHistory() {
  return client.get('/api/statistics/keywords/mapping-history');
}

export function createKeywordTopic(payload) {
  return client.post('/api/statistics/keywords/topics', payload);
}

export function saveKeywordMappings(payload) {
  return client.post('/api/statistics/keywords/mappings', payload);
}

export function undoKeywordMapping(historyId) {
  return client.post('/api/statistics/keywords/mappings/undo', { historyId });
}

export function getKeywordClusterTree(params) {
  return client.get('/api/statistics/keywords/tree', { params });
}

export function getKeywordClusterTreeHistory(params) {
  return client.get('/api/statistics/keywords/tree/history', { params });
}

export function createKeywordClusterTopic(payload) {
  return client.post('/api/statistics/keywords/tree/topics', payload);
}

export function updateKeywordClusterTopic(topicId, payload) {
  return client.patch(`/api/statistics/keywords/tree/topics/${topicId}`, payload);
}

export function deleteKeywordClusterTopic(topicId, payload) {
  return client.delete(`/api/statistics/keywords/tree/topics/${topicId}`, { data: payload });
}

export function createKeywordClusterEdge(payload) {
  return client.post('/api/statistics/keywords/tree/edges', payload);
}

export function deleteKeywordClusterEdge(edgeId, payload) {
  return client.delete(`/api/statistics/keywords/tree/edges/${edgeId}`, { data: payload });
}

export function addKeywordClusterMappings(payload) {
  return client.post('/api/statistics/keywords/tree/mappings', payload);
}

export function removeKeywordClusterMappings(payload) {
  return client.delete('/api/statistics/keywords/tree/mappings', { data: payload });
}

export function undoLastKeywordClusterAction(payload) {
  return client.post('/api/statistics/keywords/tree/undo-last', payload);
}
